// extracted by mini-css-extract-plugin
export var section = "index-module--section--w0Zuz";
export var title = "index-module--title--cp0UZ";
export var visible = "index-module--visible--Stv5f";